/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedStarterPacks.defs.js'
export * as $defs from './getOnboardingSuggestedStarterPacks.defs.js'
